import { Injectable, signal } from '@angular/core';

import { TimelineDragItem } from '../models';

@Injectable({
  providedIn: 'root',
})
// The drag in progress between the planning components (timeline board, timeline tray).
// The browser keeps a drag's data hidden until the drop, but a row has to know what is coming
// while it is still hovering - to show where it will land, or to refuse it - so the source
// records it here when the drag starts and clears it when the drag ends.
export class TimelineDragService {
  public readonly current = signal<TimelineDragItem | null>(null);

  start(item: TimelineDragItem, event: DragEvent) {
    this.current.set(item);

    // Firefox will not start a drag without some data on it.
    event.dataTransfer?.setData('text/plain', item.itemId);
    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = 'move';
    }
  }

  end() {
    this.current.set(null);
  }
}
